import { useSelector } from 'react-redux';
import { lt, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { DateTimeField, EnumSelectField, SelectField } from '@mews-commander/form';
import { ExportState } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { isCurrentProfileAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { FilterValueKey } from '../constants';
import { OwnerProfile } from './OwnerProfile';

export const ExportFilterFields = ({ reportTypes }: { reportTypes: Array<string> }) => {
    const enterpriseId = useCurrentEnterpriseId();
    const isUserAdmin: boolean = useSelector(isCurrentProfileAdmin);
    const localizeText = useLocalizeText();
    const mapReportTypeToOption = (s: string) =>
        createOption({
            value: s,
            label: localizeText({
                textKey: s as Mews.TextKey,
            }),
        });
    return (
        <Stack vertical spacing="300">
            <SelectField
                name={FilterValueKey.reportType}
                label={lt(TextKey.Type)}
                options={reportTypes.length ? reportTypes.toSorted().map(mapReportTypeToOption) : []}
            />
            <DateTimeField label={lt('Start')} required name={FilterValueKey.startDate} />
            <DateTimeField label={lt('End')} required name={FilterValueKey.endDate} />
            {enterpriseId && isUserAdmin && <OwnerProfile />}
            <EnumSelectField
                multiselect
                name={FilterValueKey.states}
                label={lt(TextKey.Status)}
                enumClass={ExportState}
                enumPrefix="ExportState"
                compact
                omitHint
            />
        </Stack>
    );
};
